import './theme_kovanen.scss';
import ITheme from '../ITheme';
import NavigationItems from '@/navigationItems';

export default class ThemeKovanen implements ITheme {
    id: string = 'kovanen';
    matchIfHostNameContainsAny: string[] = ['kovanen.'];
    name: string = 'Kovanen';
    cssClassName: string = 'theme_kovanen';
    dark: boolean = false;
    menuDark: boolean = false;
    toolbarDark: boolean = true;
    bottomNavDark: boolean = true;
    menuRight: boolean = false;
    booking: boolean = true;
    menuNavigationItems: INavigationItem[] = [
        NavigationItems.passengers,
        NavigationItems.trips,
        NavigationItems.cancelTrips,
        NavigationItems.booking,
        NavigationItems.personalInfo,
        NavigationItems.messages,
        NavigationItems.register,
        NavigationItems.accessibilityReport,
        NavigationItems.privacy,
    ];
    bottomNavNavigationItems: INavigationItem[] = [
        NavigationItems.booking,
        NavigationItems.trips,
        NavigationItems.cancelTrips,
        NavigationItems.messages,
    ];
    vuetifyTheme: any = {
        primary: '#0a0a0a',
        secondary: '#00ff00',
        accent: '#ffcb31',
        warning: '#ffcb31',
        bottomNavColor: '#ffcb31',
    };
}
